/** Afficher le réglage relances par formation (API conservée, UI masquée pour l'instant). */
export const SHOW_PER_COURSE_REMINDER_SETTINGS = false;
